import { Component, Input } from '@angular/core';

/**
 * Named item list for a donation — renders the server-built list string
 * ("1 x Sofa (XL), 1 x Lamp (S)", carries qty + size; `donation.itemsList`, see phoneLeadWizard
 * @CY-NPL-14). Shared by partner and non-Uber couriers (RP-4182). Pass an empty `label` to show
 * just the string inside a table. The donor's free text is a separate field (RP-4233).
 */
@Component({
  selector: 'rspl-donation-items',
  templateUrl: './donation-items.component.html',
})
export class DonationItemsComponent {
  @Input() donationItems?: string | null;
  @Input() label = 'Items:';
}
